import { useSelector } from 'react-redux';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { getGridLayoutGenerationInitiatingNode, getGridLayoutIdGeneratingLayout } from 'ContentEditorUI/redux/selectors/gridsLayoutGenerationSelectors';
import { getNodePositionsByTreeId } from '../redux/selectors/layoutSectionDndSelectors';
import { Z_INDEX_MAX_LAYERS } from '../lib/layoutSection/constants';
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const aiSkeletonAnimationOverride = keyframes(["100%{transform:translateX(5%);}"]);
const AISkeletonWithAnimationOverride = styled(AISkeleton).withConfig({
  displayName: "GridsLayoutGenerationOverlayContainer__AISkeletonWithAnimationOverride"
})([".hs-private.hs-private.hs-private &::after{animation:", " 3s ease-out infinite;}"], aiSkeletonAnimationOverride);
export const GridsLayoutGenerationOverlayContainer = () => {
  var _allNodePositions$gri;
  const gridLayoutId = useSelector(getGridLayoutIdGeneratingLayout);
  const nodeId = useSelector(getGridLayoutGenerationInitiatingNode);
  const allNodePositions = useSelector(getNodePositionsByTreeId);
  if (!gridLayoutId || !nodeId) {
    return null;
  }
  const targetNodePosition = allNodePositions === null || allNodePositions === void 0 || (_allNodePositions$gri = allNodePositions[gridLayoutId]) === null || _allNodePositions$gri === void 0 ? void 0 : _allNodePositions$gri[nodeId];
  if (!targetNodePosition) {
    return null;
  }
  const {
    width,
    height,
    top,
    left
  } = targetNodePosition;
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": `layout-generation-overlay__${gridLayoutId}--${nodeId}`,
    style: {
      position: 'absolute',
      top,
      left,
      width,
      height,
      pointerEvents: 'none',
      zIndex: Z_INDEX_MAX_LAYERS.LEVEL_1
    },
    children: /*#__PURE__*/_jsx(AISkeletonWithAnimationOverride, {
      height: height
    })
  });
};